import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useNavigate, useParams } from "react-router-dom";
import NoDataFound from "../../../components/NoDataFound";
import ResourceCard from "../../../components/ResourceCard";
import ResourceSkeleton from "../../../components/Skeleton/Resource";
import { useScrollDirectionClass } from "../../../components/ForMobile/useScrollDirectionClass";

const { GridView, SimCheckBox } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ModulesList = ({
  showCheckbox = true,
  loading,
  list,
  handleSelectItems,
  selectedItems,
  type,
  handleAppClick,
  hasMore,
  loadMoreData,
  isMobileView,
}) => {
  const navigate = useNavigate();
  const userData = useUnoSelector((state) => state.user);
  const params = useParams();
  const UUID = params?.uuid;

  const handleLoadMoreData = () => {
    if (loadMoreData) {
      loadMoreData();
    }
  };

  useScrollDirectionClass();

  return (
    <>
      <div id="scrollableDivModule" className="scrollable-container">
        {loading ? (
          <ResourceSkeleton length={10} />
        ) : list.length > 0 ? (
          <InfiniteScroll
            scrollThreshold={0.7}
            dataLength={list.length}
            next={handleLoadMoreData}
            hasMore={hasMore}
            loader={<ResourceSkeleton length={5} />}
            scrollableTarget="scrollableDivModule"
          >
            <>
              <GridView>
                {list.map((item, i) => {
                  return (
                    <ResourceCard
                      key={i}
                      name={item.name}
                      image={item.versions[0].data.thumbnail}
                      inActive={true}
                      showCheckbox={!item.inherit && showCheckbox && UUID !== userData.user.group.uuid}
                      checked={true}
                      resourceClick={() => navigate(`/team-management/Application/${item.uuid}`)}
                      onClick={() =>
                        selectedItems.length > 0
                          ? handleSelectItems({ id: item.uuid, data: item })
                          : handleAppClick(item.uuid)
                      }
                      checkbox={
                        !isMobileView ? (
                          <SimCheckBox
                            onChange={() => handleSelectItems({ id: item.uuid, data: item })}
                            checked={selectedItems.some((selectedItem) => selectedItem.id === item.uuid)}
                            disabled={item.inherit ?? false}
                          />
                        ) : (
                          false
                        )
                      }
                    />
                  );
                })}
              </GridView>
            </>
          </InfiniteScroll>
        ) : (
          <div className="no-data">
            <NoDataFound headText="No Module found" infoText="" />
          </div>
        )}
      </div>
    </>
  );
};

export default ModulesList;
